import { LINQ_STATUS } from "CONSTANT/statusCodes";

export const getApiErrorStatus = (error) =>
  error?.status ?? error?.response?.status;

export const isUserConfirmationError = (error) =>
  getApiErrorStatus(error) === LINQ_STATUS.UserConfirmationRequired;

export const getUserConfirmationPayload = (error) => {
  const data = error?.data ?? error?.response?.data ?? {};
  const dataList = data?.dataList;

  return {
    message: data?.message || data?.userMessage || "",
    dataList: Array.isArray(dataList) ? dataList : dataList ? [dataList] : [],
  };
};
